import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SuspendedIcon = (props) => {
  const { width = 71, height = 71 } = props;
  return (
    <Svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 71 71"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M0 35.059C0 15.712 15.697.014 35.044 0 54.45-.014 70.132 15.712 70.118 35.174c0 19.232-15.755 34.958-35.001 34.958C15.712 70.132 0 54.435 0 35.06Z"
        fill="#FF2E00"
      />
      <Path
        d="M50.193 46.197c-.014 1.01.087 1.847-.115 2.67-.26 1.052-.707 2.005-1.5 2.74-.433.39-.332.592.028.938 1.616 1.573 3.189 3.203 4.805 4.776.36.346.317.505-.058.793-10.922 8.787-26.864 8.527-37.425-.692C8.57 50.987 5.136 42.807 5.684 33.054c.347-6.06 2.583-11.47 6.305-16.26.318-.404.476-.419.837-.058 3.52 3.55 7.055 7.084 10.59 10.619.187.187.346.39.577.548-.101-1.313-.159-2.597.058-3.867.144-.85.346-1.702.736-2.467.216-.433.1-.663-.217-.98-2.611-2.554-5.18-5.151-7.79-7.705-.434-.418-.376-.606.057-.938 6.579-5.064 13.995-7.2 22.233-6.03C51.694 7.703 61.447 16.88 63.914 29.36c1.746 8.83-.317 16.852-5.771 24.008-.303.39-.447.375-.78.043a1105.048 1105.048 0 0 0-7.17-7.214Z"
        fill="#FEFEFE"
      />
      <Path
        d="M34.756 50.785c-2.886.029-6.074-.332-9.248-.909-1.327-.23-2.107-1.197-1.962-2.481.245-2.222.476-4.444.865-6.637.433-2.424 1.862-4.213 3.968-5.483.303-.187.52-.144.837.03 3.91 2.221 7.834 2.279 11.744 0 .303-.188.52-.203.837-.015 2.15 1.27 3.534 3.059 3.866 5.583.274 2.15.534 4.285.794 6.435.158 1.356-.606 2.323-2.006 2.597-3.102.62-6.218.88-9.695.88ZM35.059 18.323a7.497 7.497 0 0 1 7.517 7.488 7.482 7.482 0 0 1-7.517 7.545 7.515 7.515 0 0 1-7.517-7.487 7.482 7.482 0 0 1 7.517-7.546Z"
        fill="#242424"
      />
    </Svg>
  );
};

export default SuspendedIcon;
